import { RemoveNotification } from './features/remove-notification';
import { SetNotification } from './features/set-notification';

export const setNotificationAction = SetNotification.action;
export const removeNotificationAction = RemoveNotification.action;
